<template>
  <div>
    <ul class="bg_fff color_333 fs12">
      <li class='flex space-between'>
        <span>姓名：{{ info.compatName || info.compatName }}</span>
        <span class="ml20">性别：{{ info.compatGender|sexFilter }}</span>
        <span class="ml20" v-if="info.compatAge">年龄：{{ info.compatAge }}岁</span>
      </li>
      <li class='flex mt5 space-between'>
        <span class="">科别：{{ info.deptName || info.deptName }}</span>
        <span>开具日期: {{ info._hisCreateTime }}</span>
        <span></span>
      </li>
      <li v-if="info.orderType === 'CHINESE_RECIPE'" class="mt5">类型: {{ info.dosageForm }}</li>
      <li class="mt5 bb pb10">诊断: {{ info.diagnosis || '无' }}</li>
      <li>
        <recipe-drugs-card :info="info" :list="list" v-if="list.length>0"></recipe-drugs-card>
      </li>
      <li v-if="isPreview" class="right pt5 pb15 ml15 color_333 fs14">
        开方医生： {{ info.docName }}
      </li>
      <li v-else class="right pt5 pb15 bb color_333 fs14">
        处方医生： {{ info.docName }}
      </li>
    </ul>
  </div>
</template>

<script>
import RecipeDrugsCard from "../renewal/recipe-drugs-card";
import {sexFilter} from "../../lib/filters";

export default {
  name: "renewal-drug-info",
  components: {RecipeDrugsCard},
  filters: {
    sexFilter
  },
  props: {
    info: Object,
    list: Array,
    //是否是预览页
    isPreview: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
